// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { Web3Context } from '../context/Web3Context';

const ProtectedRoute = ({ component: Component }) => {
    const { account, guestMode } = useContext(Web3Context);
    const isAuthenticated = account || guestMode;

    return isAuthenticated ? <Component /> : <Navigate to="/feed" />;
};

export default ProtectedRoute;
